<template>
  <div class="redemption-code-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-input
        placeholder="请输入渠道号"
        v-model="params.channel"
        clearable
        size="small"
        @keyup.enter.native="redemptionCodeList('status')"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入兑换码"
        v-model="params.code"
        clearable
        size="small"
        @keyup.enter.native="redemptionCodeList('status')"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入批次号"
        v-model="params.batchNum"
        clearable
        size="small"
        @keyup.enter.native="redemptionCodeList('status')"
        class="param-input"
      ></el-input>
      <el-select
        v-model="params.app"
        size="small"
        placeholder="APP类型"
        clearable
        @change="redemptionCodeList('status')"
      >
        <el-option
          v-for="item in appList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="params.authority"
        size="small"
        placeholder="兑换权限"
        clearable
        @change="redemptionCodeList('status')"
      >
        <el-option
          v-for="item in authorityList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <!-- <el-select v-model="params.status" size="small" placeholder="兑换状态" clearable @change="redemptionCodeList('status')">
        <el-option v-for="item in statusList" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select> -->
      <el-button
        type="primary"
        size="small"
        @click="redemptionCodeList('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="codeAction('add')"
        >+新增兑换码</el-button
      >
      <el-button type="primary" size="small" @click="exportdata"
        >导出</el-button
      >
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        min-width="220"
        fixed
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="batchNum"
        label="批次号"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.batchNum || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="app"
        label="APP类型"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.app | appRule }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="channel"
        min-width="160"
        label="渠道"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.channel | channelRule }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="code"
        label="兑换码"
        align="center"
        min-width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.code || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="authority"
        label="兑换权限"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.authority | authorityRule }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" label="兑换状态" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.status | statusRule}}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="reward"
        label="兑换量"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.reward | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="usableNum"
        label="可用次数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.usableNum ? scope.row.usableNum : "0" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作者"
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.operator || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip
        align="center"
        min-width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remark || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="effectiveAt"
        label="生效时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.effectiveAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invalidAt"
        label="失效时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.invalidAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="220"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operating"
        label="操作"
        align="center"
        fixed="right"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            :disabled="scope.row.status !== 'unused'"
            size="mini"
            icon="el-icon-edit"
            @click="codeAction('edit', scope.row)"
          ></el-button>
          <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row)">删除同一批次的兑换码</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="changeSize"
      :total="total"
      v-if="total > 10"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <code-action
      ref="codeAction"
      @handlerCodeList="handlerCodeList"
    ></code-action>
  </div>
</template>
<script>
import CodeAction from "./components/codeAction";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage.js";
import API from "@/api";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: "",
      statusList: [
        {
          label: "已兑换",
          value: "used",
        },
        {
          label: "未使用",
          value: "unused",
        },
        {
          label: "已过期",
          value: "expired",
        },
      ],
      appList: [
        {
          label: "XVideos2",
          value: "ysAppVideo",
        },
        {
          label: "91约炮",
          value: "pfAppVideo",
        },
        {
          label: "雷霆加速器",
          value: "ltAppVpn",
        },
      ],
      authorityList: [
        {
          label: "兑换VIP",
          value: "shortVideoVip",
        },
        // {
        //   label: '影视VIP',
        //   value: 'filmVip',
        // },
        { label: "3天永久VIP", value: "3dPermanentVip" },
        // {
        //   label: '兑换金币',
        //   value: 'gold',
        // },
      ],
      // 兑换码列表参数
      params: {
        batchNum: "",
        channel: "",
        code: "",
        app: "",
        authority: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  filters: {
    channelRule(val) {
      if (val instanceof Array) {
        return val.join(",");
      }
      return val;
    },
    authorityRule(value) {
      switch (value) {
        case "3dPermanentVip":
          return "3天永久VIP";
        case "shortVideoVip":
          return "兑换VIP";
        case "gold":
          return "兑换金币";
      }
    },
    statusRule(val) {
      const ruleObj = {
        unused: "未使用",
        used: "已兑换",
        expired: "已过期",
      };
      return ruleObj[val] || "未知";
    },
    appRule(val) {
      const ruleObj = {
        ysAppVideo: "XVideos2",
        pfAppVideo: "91约炮",
        ltAppVpn: "雷霆加速器",
      };
      return ruleObj[val] || "未知";
    },
  },
  components: {
    CodeAction,
  },
  created() {
    /// 判断是否为超级管理员用户,只有超级管理员用户才能添加兑换金币选项
    const userInfo = local.get("userInfo"),
      role = userInfo.admin.role || "";
    if (role !== "superAdmin") {
      this.authorityList = [
        { label: "短视频VIP", value: "shortVideoVip" },
        { label: "影视VIP", value: "filmVip" },
        { label: "超级VIP", value: "superVip" },
      ];
    }
    this.redemptionCodeList();
  },
  methods: {
    // 导出数据
    exportdata() {
      let param = Object.assign({}, this.params, { role: this.role });
      let params = paramsFilter(param);
      let str = "";
      for (let key in params) {
        if (key == "startTime" || key == "endTime") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);

      let url = baseConfig.baseServerUrl + "/export/exchangecode?" + str;
      window.location.href = url;
    },
    // 请求兑换码列表
    redemptionCodeList(status) {
      if (status) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.redemptionCodeList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 删除兑换码
    // remove(row) {
    //   this.$confirm('您确定要当前选择批次的兑换码吗？', '删除提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       API.delCode({ exchangeTypeID: row.exchangeTypeID, batchNum: row.batchNum }).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '删除兑换码成功',
    //             type: 'success'
    //           })
    //           this.redemptionCodeList()
    //         } else {
    //           if (res.tip) {
    //             this.$message.error(res.tip)
    //           } else {
    //             this.$message.error('删除兑换码失败')
    //           }
    //         }
    //       })
    //     })
    //     .catch(() => { });
    // },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.redemptionCodeList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.redemptionCodeList();
    },
    // 编辑活动成功回掉
    handlerCodeList() {
      this.redemptionCodeList();
    },
    // 新增、删除tags
    codeAction(type, data) {
      this.$refs.codeAction.open(type, data);
    },
  },
};
</script>
<style scoped></style>
